export const floatToDollar = (float: number) =>
  float.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
